import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class FaqNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('FAQ', _('menu.label.faq'), AppRoute.Help, _('a11y.link.faq'), 'LINKS');
  }
}
